import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/ui-common/src/CircularProgress/CircularProgress.tsx";
var _excluded = ["color", "disableShrink", "size", "thickness"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { CircleWrapper, CircularProgressWrapper, SVGWrapper } from './CircularProgress.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export var CircularProgress = function CircularProgress(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$disableShrink = _ref.disableShrink,
      disableShrink = _ref$disableShrink === void 0 ? false : _ref$disableShrink,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 40 : _ref$size,
      _ref$thickness = _ref.thickness,
      thickness = _ref$thickness === void 0 ? 3.6 : _ref$thickness,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(CircularProgressWrapper, _objectSpread(_objectSpread({
    color: color,
    role: "progressbar",
    style: {
      width: size,
      height: size
    }
  }, other), {}, {
    children: /*#__PURE__*/_jsx(SVGWrapper, {
      viewBox: "22 22 44 44",
      children: /*#__PURE__*/_jsx(CircleWrapper, {
        cx: 44,
        cy: 44,
        r: 20.2 + (3.6 - thickness) / 2,
        fill: "none",
        strokeWidth: thickness,
        disableShrink: disableShrink
      })
    })
  }));
};